import { replaceVariable } from "../utils/string";
import { urlFullFill } from "../utils/url";
import shuffle from "lodash/fp/shuffle";
import { LocalStorage } from "./LocalStorage";
import { ROOT_GLOBAL } from "../global/root";

export class Site {
  constructor(
    id,
    domain,
    name,
    siteMeta,
    sales,
  ) {
    this.id = id;
    this.domain = domain;
    this.name = name;
    /** @type {SiteMeta}*/
    this.siteMeta = siteMeta;
    /** @type {[SiteSales]}*/
    this.sales = sales;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Site(
        input.id,
        input.domain,
        input.name,
        SiteMeta.fromApiObject(input.site_meta),
        SiteSales.fromApiArray(input.sales),
      )
    }

    return new Site();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Site.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Site.fromApiObject(input)];
    }

    return [];
  }

  getUrl() {
    let sale = this.sales && this.sales[0];
    let url = sale?.url ? sale.url : (this.siteMeta.url || this.siteMeta.canonicalUrl || this.domain);
    if (!LocalStorage.hasExtension()) {
      let id = sale?.id ? sale.id : this.id;
      url = `${ROOT_GLOBAL.SHORT}${id}?${sale?.id ? "sale_id" : "site_id"}=${id}`;
    }
    return urlFullFill(url);
  }

  genHtml(isFullWidth = false) {
    return replaceVariable(require("html-loader!../components/AvailableStore/item.html"), {
      dataId: this.id || "",
      class: `${this.sales && this.sales[0] ? ' sale' : ''}${!this.siteMeta?.logoUrl || !this.siteMeta?.background ? " no-white-logo" : ""}${!this.siteMeta?.background ? " no-background" : ""}`,
      href: this.getUrl(),
      discountName: (this.sales && this.sales[0]) ? this.sales[0].name : '',
      src: this.siteMeta.logoUrl || "",
      classImage: "",
      srcWhite: this.siteMeta.logoUrl || "",
      simpleName: Site.getNameSite(this.name),
      siteName: this.name || "",
      backgroundUrl: this.siteMeta?.background ? CSS.escape(`${this.siteMeta.background}${this.siteMeta.background.indexOf('?') !== -1 ? '&' : '?'}${!isFullWidth ? "max-w=500" : ""}`) : "",
      classSiteInfo: "",
      title: !LocalStorage.hasExtension() ? $.i18n("sites_installDutycast") : this.name,
    });
  }

  static getNameSite(name = "") {
    if (!name) return "";
    let isShortName = false;
    const maxLengthName = 29;

    if (name.length > maxLengthName) {
      isShortName = true;
    } else {
      let words = name.split(" ");
      isShortName = !Site.isValidWords(words);
    }
    return isShortName ? Site.getShortName(name) : name;
  }

  static isValidWords(words = []) {
    let isValid = true;
    const maxLengthWord = 16;
    for (let index = 0; index < words.length; index++) {
      const word = words[index];
      if (word.length > maxLengthWord) {
        isValid = false;
        return isValid;
      }
    }

    return isValid;
  }

  static getShortName(name = "") {
    if (!name) return "";
    let result = "";
    let words = name.split(" ");
    for (let index = 0; index < words.length; index++) {
      const word = words[index];
      if (word.includes("&")) {
        result += this.getShortName(word.replace("&", " "));
      } else {
        result += word.substring(0, 1);
      }
    }
    return result;
  }
}

export class SiteMeta {
  constructor(
    url,
    logoUrl,
    canonicalUrl,
    background,
  ) {
    this.url = url;
    this.logoUrl = logoUrl;
    this.canonicalUrl = canonicalUrl;
    this.background = background;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new SiteMeta(
        input.url,
        input.logo_url,
        input.canonical_url,
        input.background || this.getDefaultBackground(),
      )
    }

    return new SiteMeta();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => SiteMeta.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [SiteMeta.fromApiObject(input)];
    }

    return [];
  }

  static getDefaultBackground() {
    let listDefault = [
      "https://cdn.dutycast.com/dutycast/static/media/sites/default/default_10.jpg",
      "https://cdn.dutycast.com/dutycast/static/media/sites/default/default_20.jpg",
      "https://cdn.dutycast.com/dutycast/static/media/sites/default/default_30.jpg",
      "https://cdn.dutycast.com/dutycast/static/media/sites/default/default_40.jpg",
      "https://cdn.dutycast.com/dutycast/static/media/sites/default/default_50.jpg",
      "https://cdn.dutycast.com/dutycast/static/media/sites/default/default_60.jpg",
      "https://cdn.dutycast.com/dutycast/static/media/sites/default/default_70.jpg",
      "https://cdn.dutycast.com/dutycast/static/media/sites/default/default_80.jpg",
    ];
    if (!listDefault.length) return "";
    return shuffle(listDefault)[0];
  }
}

export class SiteSales {
  constructor(
    url,
    name,
    id,
  ) {
    this.url = url;
    this.name = name;
    this.id = id;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new SiteSales(
        input.url,
        input.name,
        input.id,
      )
    }

    return new SiteSales();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => SiteSales.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [SiteSales.fromApiObject(input)];
    }

    return [];
  }
}